export default "__VITE_ASSET__Dw2UoM_W__"